import { ResourceOptions } from 'react-admin';
import { FaClock } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.socialTradingAgentsConfig;
export const icon = FaClock;
export const options: ResourceOptions = {
  label: 'module.socialTrading.agentsConfig',
};
